//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
SPLM.Motion.ConnectorCoefficientTypes = Object.freeze({
    "Constant" : "Constant", "Spline" : "Spline", "Profile2d" : "Profile2d", "Profile3d" : "Profile3d", "ExpressionAndSpline" : "ExpressionAndSpline", "ExpressionAndProfile2d" : "ExpressionAndProfile2d", "ExpressionAndProfile3d" : "ExpressionAndProfile3d"});

SPLM.Motion.BushingGeneralCoefficientMoveTypes = Object.freeze({
    "Translational" : "Translational", "Torsional" : "Torsional"});

SPLM.Motion.BushingGeneralCoefficientTypes = Object.freeze({
    "TranslationalStiffness" : "TranslationalStiffness", "TranslationalDamping" : "TranslationalDamping", "TranslationalPreload" : "TranslationalPreload", "TorsionalStiffness" : "TorsionalStiffness", "TorsionalDamping" : "TorsionalDamping", "TorsionalPreload" : "TorsionalPreload"});

SPLM.Motion.BushingCylindricalCoefficientTypes = Object.freeze({
    "Stiffness" : "Stiffness", "Damping" : "Damping", "Preload" : "Preload"});

SPLM.Motion.BushingSphericalCoefficientTypes = Object.freeze({
    "Stiffness" : "Stiffness", "Damping" : "Damping", "Preload" : "Preload"});

SPLM.Motion.ForceValueTypes = Object.freeze({
    "Constant" : "Constant", "Function" : "Function", "Profile" : "Profile"});

SPLM.Motion.GcouplerMovementTypes = Object.freeze({
    "Rotation" : "Rotation", "Translation" : "Translation"});

SPLM.Motion.CurveParameterizedTypes = Object.freeze({
    "Curvature" : "Curvature", "Spacing" : "Spacing"});

SPLM.Motion.PlayMode = Object.freeze({
    "PlayOnce" : "PlayOnce", "Loop" : "Loop", "Retrace" : "Retrace"});

SPLM.Motion.AnimationSpeedControlType = Object.freeze({
    "RealTime" : "RealTime", "StepByStep" : "StepByStep"});

SPLM.Motion.ActiveView = Object.freeze({
    "All" : "All", "Work" : "Work"});

SPLM.Motion.ParamOverrideState = Object.freeze({
    "Undefined" : "Undefined", "Override" : "Override"});

SPLM.Motion.MathfunctionUnitConversionPolicy = Object.freeze({
    "Ignore" : "Ignore", "Apply" : "Apply"});

SPLM.Motion.SolverPerformanceReportDisplayVariableType = Object.freeze({
    "SolverSummary" : "SolverSummary", "ComputationSummary" : "ComputationSummary", "EvaluateConstraints" : "EvaluateConstraints", "EvaluateRightHandSide" : "EvaluateRightHandSide"});

SPLM.Motion.SolverPerformanceReportType = Object.freeze({
    "Time" : "Time", "Percentage" : "Percentage"});

export default SPLM;